export default "__VITE_ASSET__DbQpPih5__"